import {ihSource as staticIhSources} from 'dicts/calendarResources';

const isPlainObject = value =>
	!!value && typeof value === 'object' && !Array.isArray(value);

export const getAccountIhSources = account => {
	const ihSources = account?.meta?.ihSources;

	if (!isPlainObject(ihSources)) {
		return {};
	}

	return Object.entries(ihSources).reduce((acc, [key, label]) => {
		if (typeof key !== 'string' || key === '') {
			return acc;
		}

		if (typeof label !== 'string' || label === '') {
			return acc;
		}

		return {
			...acc,
			[key]: label,
		};
	}, {});
};

export const getMergedIhSources = account => ({
	...staticIhSources,
	...getAccountIhSources(account),
});

export const getIhSourceOpts = account => {
	const customIhSources = getAccountIhSources(account);

	return Object.entries(getMergedIhSources(account)).map(([value, label]) => ({
		value,
		label,
		isCustom: Object.prototype.hasOwnProperty.call(customIhSources, value),
	}));
};

export const getIhSourceLabel = ({account, value}) => {
	if (!value) {
		return null;
	}

	const mergedIhSources = getMergedIhSources(account);
	const label = mergedIhSources[value];

	if (!label) {
		return null;
	}

	return {
		label,
		isCustom: Object.prototype.hasOwnProperty.call(getAccountIhSources(account), value),
	};
};
